import React from "react";

const InputText = ({ placeholder }) => {
  return (
    <input
      type="text"
      className="form-input block w-full text-black rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary sm:text-sm"
      placeholder={placeholder}
    />
  );
};

export default InputText;
